module.exports = __webpack_public_path__ + "img/motobomba.b6b20d17.png";